var map = {
	"./dhl_logo.png": "542f",
	"./flash_logo.png": "c17f",
	"./jt_logo.png": "b606",
	"./kerry_logo.png": "b821",
	"./scg_logo.png": "9037",
	"./shopee_logo.png": "713b",
	"./thaipost0_logo.png": "ef4a",
	"./thaipost_logo.png": "70d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da0f";